import React from "react";
import { Navigate } from "react-router-dom";

const RequireAuth = ({ children }) => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const isAuthenticated = sessionData?.token ? true : false;
  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/auth/login" />;
  }

  return children;
};

export default RequireAuth;
